<template>
    <div class="wrap">
        <div class="head">
            <div class="logo">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/logo_1.png" class="logo_1">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/logo_2.png" class="logo_2">
            </div>
            <div class="kv">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/kv.png">
            </div>
            <div class="bottom">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bottom.png">
            </div>
        </div>
        <div class="content">
            <div class="title">
                <span>{{title}}</span>
            </div>
            <div class="case" @click="pdfzoom">
                <pdf
                        :page="pageNum"
                        :src="url"
                        @progress="loadedRatio = $event"
                        @num-pages="pageTotalNum=$event"
                        style="width: 400px"
                ></pdf>
                <label class="zoom" @click="pdfzoom"></label>
            </div>
            <div class="questions" v-for="(item,index) in question" v-bind:key="index">
                <div class="question">
                    <span>
                        {{item.question}}({{item.type==1?"单选题":"多选题"}})
                    </span>
                </div>
                <div class="resolve" v-for="(resolve,i) in item.resolves" v-bind:key="i" @click="questionSelected(item,resolve)">
                        <span class="uncheck" v-if="resolve.check==0"></span>
                        <span class="check" v-if="resolve.check==1"></span>
                        <label >{{resolve.resolve}}</label>
                </div>
            </div>
            <div class="submit" :class="pdfFinish?'enable':'disable'" @click="toSubmit">
                <label>{{submit}}</label>
            </div>
        </div>
    </div>
</template>

<script>
    import pdf from 'vue-pdf'
    import {ksdDocLearner} from "@/assets/js/api";

    export default {
        name: "RepToken",
        components: {
            pdf
        },
        data(){
            return{
                pdfFinish:false,
                title:"达标学者-学习训练营",
                valueOne: '',
                submit:"提交",
                question: [
                    {
                        question:"1.STRONG研究中培哚普利/氨氯地平4mg/ 5mg治疗2周，血压降幅可达",
                        type:"1",
                        resolves:[{
                            resolve:"A、18/16mmHg",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"B、21/11mmHg",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"C、29/16mmHg",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"D、42/23mmHg",
                            check:0,
                            isAnswer:0
                        }]},
                    {
                        question:"2.AVANGARD研究显示，培哚普利/氨氯地平10/5mg（36.6%），治疗3个月，血压达标率可达",
                        type:"1",
                        resolves:[{
                            resolve:"A、85.6%",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"B、90.2%",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"C、93.5%",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"D、98.7%",
                            check:0,
                            isAnswer:0
                        }]},
                    {
                        question:"3.EMERALD研究显示，培哚普利/氨氯地平10/5mg（20.8%）治疗4个月，依从性高达",
                        type:"1",
                        resolves:[{
                            resolve:"A、98%",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"B、90%",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"C、86%",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"D、80%",
                            check:0,
                            isAnswer:0
                        }]
                    },
                    {
                        question:"4.ASCOT研究显示，氨氯地平5-10mg±培哚普利4-8mg可显著降低心血管死亡、卒中死亡和肾损伤风险分别为",
                        type:"1",
                        resolves:[{
                            resolve:"A、24%，29%，15%",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"B、29%，25%，18%",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"C、20%，18，15%",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"D、18%，22%，24%",
                            check:0,
                            isAnswer:0
                        }]
                    },
                ],
                url: "https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/model.pdf",
                pageNum: 1,
                pageTotalNum: 1,
                loadedRatio: 0,
                docId:this.$store.state.ksd_docId
            }
        },
        methods:{
            toIndex(){
                this.$router.push({path:"./repIndex"})
            },
            questionSelected(item,resolve){
                let type = item.type
                if(type==1){//单选题
                    for(let r of item.resolves){
                        r.check = 0
                    }
                    resolve.check=1
                }else{  //多选题
                    if(resolve.check==0){
                        resolve.check=1
                    }else{
                        resolve.check=0
                    }
                }
            },
            getScore(index){
                const question = this.question[index-1]
                let resolves = question.resolves;

                let score = true;
                for(let resolve of resolves){
                    if(resolve.check!=resolve.isAnswer){
                        score = false
                    }
                }
                return score
            },
            getAnswer(index){
                const question = this.question[index-1]
                let resolves = question.resolves;
                let answer="";
                for(let resolve of resolves){
                    if(resolve.check==1){
                        answer+=resolve.resolve+","
                    }
                }
                return answer.substring(0,answer.length-1)
            },
            toSubmit(){

                let resolve ="";
                let score=0;

                if(!this.pdfFinish){
                    this.$toast("请先学习相关文献")
                    return
                }

                for(let i=1;i<=this.question.length;i++){
                    let docAnswer = this.getAnswer(i);
                    if(docAnswer ==null||docAnswer==""){
                        this.$toast("请选择第"+i+"题答案")
                        return;
                    }
                    resolve+=docAnswer+";"
                    if(this.getScore(i)) score+=25 //一题25分
                }
                let  optag  = this.learnerSubmit(this.docId,score,resolve)
                if(optag){
                    this.$router.push({name:"docLearnerScore",params:{score:score}})
                }

            },
            async learnerSubmit(docId,score,resolve){
                const res = await ksdDocLearner({docId,score,resolve})
                return res.data.success
            },
            pdfzoom(){
                this.$router.push({path:"pdf",query:{url:"https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/model.pdf",docId:this.docId}})
            },
            getNumPages() {
                let loadingTask = pdf.createLoadingTask(this.url)
                loadingTask.promise.then(pdf => {
                    this.numPages = pdf.numPages
                }).catch(err => {
                    console.error('pdf 加载失败', err);
                })
            },

        },
        mounted() {
            this.pdfFinish = this.$store.state.ksd_pdf
            console.log(this.pdfFinish,"2323")
            this.getNumPages()
        },
    }
</script>

<style scoped lang="scss">
    .wrap{
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bg.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-flow: column;
        overflow: scroll;
    }
    .content{
        flex-grow: 1;
    }
    .head{
        width: 100%;
        position: relative;
    }
    .head .logo{
        width: 100%;
        display: flex;
        flex-flow: row;
        justify-content: space-between;
        margin: 10px 0;
        .logo_1{
            width: 30px;
            height: 30px;
            margin-left: 20px;
        }
        .logo_2{
            width: 90px;
            height: 30px;
            margin-right: 20px;
        }
    }
    .kv{
        width: 100%;
        height: 180px;
        display: flex;
        justify-content: center;
        img{
            width: 275px;
            height: 157px;
        }
    }
    .bottom{
        position: absolute;
        right: 0;
        bottom: -55px;
        img{
            width: 120px;
            height: 120px;
        }
    }
    .content{
        flex-grow: 1;
    }
    .content .title{
        color: #2c9a58;
        text-align: left;
        font-size: 20px;
        margin: 3px 20px;
        font-weight: bold;
    }
    .content .case{
        width: 90%;
        height: 230px;
        background: #ddd;
        margin: 0 auto;
        z-index: 100;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .content .case .zoom{
        position: absolute;
        display: block;
        width: 28px;
        height: 28px;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/icon-zoom.png") no-repeat;
        background-size: cover;
        bottom: 15px;
        right: 15px;
    }
    .questions{
        text-align: left;
        margin-top: 10px;
        .question{
            margin: 10px auto;
            width: 95%;
            background: #eee;
            border-radius: 2px;
            border-left: 3px #2c9a58 solid;
            font-weight: bold;
            font-size: 14px;
            padding: 5px 0 5px 5px;
        }
        .resolve{
            margin: 5px 10px 5px 20px;
            display: flex;
            flex-direction: row;
            align-items: center;
            font-size: 14px;
        }
    }
    .submit{
        width: 90%;
        height: 30px;
        line-height: 30px;
        margin: 30px auto;
        border-radius: 5px;
        color: #FFF;
        font-size: 16px;
    }

    .enable{
        background: #2c9a58;
    }

    .disable{
        background: #999;
    }
        .uncheck{
            display: block;
            width: 15px;
            height: 15px;
            background: transparent;
            border: #333 1px solid;
            border-radius: 50%;
            margin: 3px 5px;
        }
        .check{
            display: block;
            width: 15px;
            height: 15px;
            background: #2c9a58;
            border: #2c9a58 1px solid;
            border-radius: 50%;
            margin: 3px 5px;
        }
    .pdf{
        height: 100px;
    }



</style>